import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import {
  GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
  GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
  GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
  fetchIndividualDevelopmentPlanList,
} from 'data/IndividualDevelopmentPlans/actions';
import { isNoProgressTestResultsWithinIdpPeriodError } from 'data/IndividualDevelopmentPlans/generateErrors';

export function generateHfv4IndividualDevelopmentList(groupIdpId) {
  return (dispatch) => {
    const method = 'POST';
    const url = buildUrl(`/group-compulsory-idps/${groupIdpId}`);

    return dispatch(generateIndividualDevelopmentListRequest()).payload
      .then((response) => {
        dispatch(generateIndividualDevelopmentListSuccess(response));
        return null;
      })
      .catch((error) => {
        dispatch(generateIndividualDevelopmentListFailure(error));
        return error;
      })
      .then((error) => {
        dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
        return error;
      });

    function generateIndividualDevelopmentListRequest() {
      return ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: fetch(url, { method }),
        method,
        url,
      });
    }

    function generateIndividualDevelopmentListSuccess(response) {
      return ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function generateIndividualDevelopmentListFailure(error) {
      return ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method,
        url,
        error,
        disableDefault: isNoProgressTestResultsWithinIdpPeriodError(error),
      });
    }
  };
}



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanListView/actions.js